import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function EcuadorZaeCafeArabigoLayer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="vw_hg000_zae_cafe_arabigo"
      format="image/png"
      version="1.1.1"
      transparent
      tiled
      url={`https://g8a078u1g6.execute-api.eu-west-1.amazonaws.com/app/wms-ecuador/demarcacion/E25k/wms`}
      opacity={opacity}
    />
  )
}

export default EcuadorZaeCafeArabigoLayer
